import { DatabaseStreamState } from '@databases/rovo-bridge';

/**
 * Waits for the current database stream to finish before starting a queued AI field request.
 */
export const waitForDatabaseStreamIdle = async (): Promise<void> => {
  const streamState = DatabaseStreamState.getInstance();
  if (!streamState.isStreamingActive) {
    return;
  }

  await new Promise<void>((resolve) => {
    const unsubscribe = streamState.subscribe(({ isStreaming }) => {
      if (!isStreaming) {
        unsubscribe();
        resolve();
      }
    });
  });
};
